<template>
  <div class="wrapper tw-flex tw-mx-16">

    <div class="tw-container tw-mx-auto">
      <div class="tw-text-center tw-mb-12">
        <h2 class="tw-text-6xl tw-font-bold tw-text-center tw-mb-12">Just Checking!</h2>
        <p class="lg:tw-mx-64">Hot food is best served hot. If you are looking at options of pasta or meatballs you want your eaters to enjoy food as it’s meant to be! Add some chafing dishes and sternos to help keep food hot and to better hold and display hot catering options.</p>
      </div>
      
      <h2 class="tw-text-5xl tw-text-orange-medium tw-animate-pulse tw-font-bold tw-text-center tw-mb-12">Alex, Make this a Carousel</h2>

      <div class="tw-mb-24">
        <div class="tw-flex tw-flex-wrap tw--mx-1 lg:tw--mx-4">
          <template v-if="state.recommendationsLoaded">
            <RecommendationProduct
              class="tw-flex flex-1 tw-px-8 tw-flex-grow-1 tw-my-1 tw-px-1 tw-w-full md:tw-w-1/2 lg:tw-mb-8 lg:tw-px-8 lg:tw-w-1/4"
              v-for="product in state.recommendations"
              :key="(product as Product).id"
              :product="product"
              :size="'full'"
              :isLoading="false"
              @handleProductAdd="addProduct"
            />
          </template>

          <template v-else>
            <div 
              class="tw-my-1 tw-px-1 tw-w-full md:tw-w-1/2 lg:tw-w-1/3 xl:tw-mb-8 xl:tw-px-4 xl:tw-w-1/4" 
              v-for="idx in 4" 
              :key="'loader-'+idx">
              <div class="tw-overflow-hidden tw-rounded-3xl tw-shadow-lg tw-bg-white tw-block tw-cursor-pointer tw-group tw-w-full tw-block">
                <div class="tw-overflow-hidden tw-block tw-h-auto tw-w-full">
                  <SkeletonLoader class="tw-w-full tw-h-96" />
                </div>
                <div class="tw-mx-12 tw-mt-8 tw-pb-8">
                  <SkeletonLoader class="tw-w-full tw-h-12" />
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>

      <div class="tw-flex">
        <router-link
          :to="{ name: 'menu'}"
          class="tw-mr-4 tw-bg-transparent tw-border-gray-400 tw-border tw-rounded-full tw-text-gray-500 hover:tw-border-orange-medium hover:tw-text-orange-medium tw-uppercase tw-font-bold tw-px-16 tw-mb-4 tw-py-4 tw-transition-all tw-duration-200" 
          >
          Back
        </router-link>

        <router-link
          :to="{ name: 'review-bag'}"
          class="tw-ml-auto tw-bg-orange-medium hover:tw-bg-orange-dark hover:tw-text-white tw-border-orange-medium tw-border tw-rounded-full tw-text-white tw-uppercase tw-font-bold tw-px-16 tw-mb-4 tw-py-4 tw-transition-all tw-duration-200" 
          >
          Continue
        </router-link>
      </div>
    </div>    
  </div>
</template>

<script setup lang="ts">
  import {
    reactive, computed, onMounted, ref
  } from 'vue';

  // Data
  import { useBasketStore } from '../../stores/basket';
  import { useMenuStore } from '../../stores/menu';
  import { useUserStore } from '../../stores/user';
  import type Product from '../../classes/Product';

  // Components
  import RecommendationProduct from './_RecommendationProduct.vue';
  import SkeletonLoader from '../../components/SkeletonLoader.vue';

  const basketStore = useBasketStore();
  const menuStore = useMenuStore();
  const userStore = useUserStore();

  const state = reactive({
     recommendations: [] as Product[],
     recommendationsLoaded: false
   })

  onMounted(() => {
    state.recommendationsLoaded = false;
    if (userStore.userLocation != null) {
      menuStore.fetchRecommendations().then((products: Product[]) => {
        state.recommendations = products;
        state.recommendationsLoaded = true;
      });
    } else {
      alert('TODO: A location has not been selected.')
    }
  })

  // TODO: Make this accept a qty too
  const addProduct = (id: string) => {
    basketStore.addProduct(id, 1, "", [], [], undefined)
  }

</script>

<style>
.menu {
  display: flex;
  flex-wrap: wrap;
}

</style>
